<template>
  <div id="button-row">
    <div class="row">
      <div class="col-sm-12">
        </div>
        <div class="col-sm-10 right-buttons">
          <base-button
            :title="$t(`app.base_states.skip`)"
            :classNames="`btn btn-outline btn-default button rounded mr-20`"
            @clicked="skip"
          />
           <base-button
            :title="$t(`app.base_states.copy`)"
            :classNames="`btn btn-warning button rounded mr-20`"
            @clicked="copy"
          />
          <base-button
            :title="$t(`app.base_states.buttons.save`)"
            :classNames="`btn btn-orange button rounded`"
            @clicked="save"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseButton from "@/components/shared/buttons/BaseButton";

export default {
  name: "ButtonRow",
  components: {
    "base-button": BaseButton
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    skip() {
      this.$emit("skip");
    },
    save() {
      this.$emit("save");
    },
    copy() {
      this.$emit("copy");
    }
  }
};
</script>

<style lang="scss">
#button-row {
  .right-buttons {
    .base-button {
      margin-left: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/base_states/ButtonRow.vue